import { useState } from "react";
import styled, { keyframes } from "styled-components";
import { ScanArrow } from "../../assets/images";
import ReactGA from "react-ga4";

const CustomWheel = ({
  size,
  segments,
  selectedSeg,
  rotate,
  onResultSelected,
  onRotate,
  segmentColors,
}) => {
  let audio = new Audio(require("../../assets/spin.wav"));
  const isUAT =
    window.location.hostname.includes("uat") ||
    window.location.hostname.includes("localhost");

  const getRotateAngle = () => {
    let angle = 360 - (360 / segments.length) * segments.indexOf(selectedSeg);
    return Number(7200 + angle) + "deg";
  };

  const handleClick = () => {
    audio.play();
    onRotate();
    if (!isUAT) {
      ReactGA.event({
        category: "Custom Events",
        action: "Clicked on the Spin Wheel",
        label: "Clicked on the Spin Wheel",
      });
    }
  };

  return (
    <SpinWheelContainer size={size}>
      <SpinWheel
        size={"96%"}
        angle={getRotateAngle()}
        segments={segments}
        rotate={rotate}
        onAnimationEnd={onResultSelected}
        segmentColors={segmentColors}
        // spinKey={}
      >
        <TextContainer>
          {segments.map((segment, index) => (
            <Text even={index % 2 === 0} deg={index * (360 / segments.length)}>
              <span>{segment.split(" ")[0]}</span>
              <span>{segment.split(" ")[1]}</span>
            </Text>
          ))}
        </TextContainer>
      </SpinWheel>
      <SpinButton rotate={rotate} onClick={() => handleClick()}>
        SPIN
      </SpinButton>
      <Arrow src={ScanArrow} />
    </SpinWheelContainer>
  );
};

const getBackground = (colors) => {
  let style = [];
  let anglePerSeg = 360 / colors.length;

  style.push(`#${colors[0] || "9b59b6"} ${0}deg, #${colors[0] || "9b59b6"} ${
    anglePerSeg / 2
  }deg,${`#FFE3AB`} ${anglePerSeg / 2}deg, 
  ${`#FFE3AB`} ${anglePerSeg / 2 + 1}deg`);
  colors.forEach((clr, idx) => {
    if (idx !== 0) {
      let segmentAngle = anglePerSeg / 2 + (idx - 1) * anglePerSeg;
      style.push(
        `${`#${clr || "9b59b6"}`} ${segmentAngle}deg, 
        ${`#${clr || "9b59b6"}`} ${segmentAngle + anglePerSeg}deg,
        ${`#FFE3AB`} ${segmentAngle + anglePerSeg}deg, 
        ${`#FFE3AB`} ${segmentAngle + anglePerSeg + 1}deg`
      );
    }
  });
  style.push(
    `#${colors[0] || "9b59b6"} ${360 - anglePerSeg / 2}deg, #${
      colors[0] || "9b59b6"
    } ${0}deg`
  );

  // style.push(`,${'#c64dfd'} ${0}deg`);
  return `conic-gradient(${style.join(",")})`;
};
// FF15D9
// 5C0451
const Arrow = styled.img`
  width: 1.25rem;
  position: absolute;
  top: 0rem;
  transform: rotate(0deg);
  zindex: 999;
`;
const SpinWheelContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${(props) => props.size};
  height: ${(props) => props.size};
  background: linear-gradient(#ffe3ab, #e4a448);
  border-radius: 50%;
  overflow: hidden;
`;

const breatheAnimation = keyframes`
 0% {   height: 3rem;
  width: 3rem; }
 30% {   height: 3.5rem;
  width: 3.5rem; }
 40% {   height: 4rem;
  width: 4rem;}
 100% {   height: 3rem;
  width: 3rem; }
`;

const SpinButton = styled.div`
  height: 3rem;
  width: 3rem;
  border-radius: 50%;
  color: #5c1e7a;
  background: linear-gradient(90deg, #ffe3ab, #e4a448);
  position: absolute;
  zindex: 99;
  display: flex;
  font-size: 0.9rem;
  justify-content: center;
  align-items: center;
  animation-name: ${(props) => (props.rotate ? null : breatheAnimation)};
  animation-duration: 1s;
  animation-iteration-count: infinite;
  border: 3px solid #5c1e7a;
`;

const SpinWheel = styled.div`
  width: ${(props) => props.size};
  height: ${(props) => props.size};
  border-radius: 50%;
  background: ${(props) => getBackground(props.segmentColors)};
  // background: radial-gradient(#5c1e7a, #e4a448);
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${(p) =>
      p.rotate
        ? keyframes`
  0% {
  transform: rotate(0deg);
  }
  100% {
  transform:rotate(${p.angle});
  }
  `
        : "none"}
    15s ease forwards;
`;

const TextContainer = styled.div`
  width: 90%;
  height: 90%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: rotate(-90deg);
`;
const Text = styled.div`
  color: ${(props) => (props.even ? "#5C1E7A" : "#FFE3AB")};
  font-size: 0.75rem;
  position: absolute;
  text-align: right;
  width: 100%;
  display: flex;
  flex-direction: column;
  &:nth-child(n) {
    transform: ${(props) => `rotate(${props.deg}deg)`};
  }
  > span:nth-child(1) {
    font-size: 0.9rem;
    font-weight: 700;
  }
  > span:nth-child(2) {
    font-size: 0.7rem;
    font-weight: 500;
  }
`;

export default CustomWheel;
